// NPM Imports
import React, { Component } from "react";
import { Button } from "@revvsales/components";

class QuotationFillerBottomBanner extends Component {
  state = {};

  render() {
    return (
      <div className="quotationbar-options">
        <div className="quotationbar-options-wrapper">
          <div className="bottom-banner-title">
            {/* <div className="bottom-banner-header">
              Your document requires your approval
            </div> */}
            <div className="bottom-banner-subheader">
              Please fill the form fields in this document and click{" "}
              <span className="bottom-banner-header"> Submit </span> to initiate
              the eSignature process.
            </div>
          </div>
          <div className="bottom-banner-buttonwrapper bottom-banner-filler-buttons">
            <Button
              className="approve-document"
              isLoading={this.props.showBtnLoader}
              onClick={() =>
                this.props.togglePopUp("submitDecline", true, "submit")
              }
              id={"SubmitBtn".replace(/ +/g, "-").toLowerCase()}
              data-test="quotationTopbar-upgrade-stage-btn">
              Submit
            </Button>
            <Button
              className="reject-document"
              isLoading={this.props.showBtnLoader}
              onClick={() =>
                this.props.togglePopUp("submitDecline", true, "decline")
              }
              id={"Decline".replace(/ +/g, "-").toLowerCase()}
              data-test="quotationTopbar-upgrade-stage-btn">
              Decline
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
export default QuotationFillerBottomBanner;



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/QuotationBottomBar/QuotationFillerBottomBanner/index.js